module.exports = __webpack_public_path__ + "static/media/Grenada - GD.e0a9d847.png";